export const INTERACTION_TYPE = {
    BUTTON: "button",
    LINK: "link",
    PAGE: "page"
}